import React, {useState} from 'react';
import {Button, CardBody, Col, Form, FormGroup, Input, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {student_strings} from "../../../translations/student_translations";
import Row from "reactstrap/es/Row";
import {resource_strings} from "../../../translations/resource_translations";
import resourceHelper from "../../../helpers/ResourceHelper";
import businessHelper from "../../../helpers/BusinessHelper";
import businessApiService from "../../../api/business-api-service";
import {common_strings} from "../../../translations/common_translations";
import RankTableRow from "../../Tables/RankTableRow";
import localeHelpers from "../../../helpers/LocaleHelper";
import Label from "reactstrap/es/Label";
import groupHelpers from "../../../helpers/GroupHelper";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const icons = [
    "star",
    "gym",
    "yoga",
    "belt",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "zero",
]

const colors = [
    "FFFFFF",
    "6F5374",
    "FEE12B",
    "C43418",
    "36873E",
    "3E7DB5",
    "572509",
    "000000",
]

const RanksOverview = (props) => {
    const [show_loader, setShowLoader] = useState(false);
    const [ranks, setRanks] = useState(businessHelper.business().student_ranks);
    const [rank, setRank] = useState(resourceHelper.emptyRank());
    const [showRank, setShowRank] = useState(false);

    const [value, setValue] = useState(0); // integer state
    //return () => setValue(value => ++value); // update the state to force render

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    const deleteRank = (e, rank) => {
        e.preventDefault();

        businessApiService.deleteRank(rank.id)
            .then(res => {
                businessHelper.saveUserSession(res)
                setRanks(res.user.student_ranks);
                setShowRank(false);
            })
            .catch(function (error) {
                console.log(JSON.stringify(error));
            });
    };

    const assignRank = (e, rank) => {
        if (props.studentId) {
            businessApiService.assign_rank_to_student(rank.id, props.studentId)
                .then(res => {
                    props.onStudentRankUpdated(res)
                    setShowRank(false);
                })
                .catch(function (error) {
                    console.log(JSON.stringify(error)); // TODO
                });
        }
    }

    const unassignRank = (e, rank) => {
        businessApiService.unassign_rank_from_student(rank.id, props.studentId)
            .then(res => {
                props.onStudentRankUpdated(res)
                setShowRank(false);
            })
            .catch(function (error) {
                console.log(JSON.stringify(error)); // TODO
            });
    }

    const editRank = (e, rank) => {
        e.preventDefault();
        setRank(rank);
        setShowRank(true)
    };

    const renderTableData = () => {
        return groupHelpers.groups()
            .map((rank, index) => {
                return (
                    <RankTableRow rank={rank} key={rank.id} deleteRank={deleteRank} editRank={editRank}
                                  assignRank={assignRank} unassignRank={unassignRank} studentId={props.studentId}
                                  studentRanks={props.studentRanks}
                                  showMessage={props.showMessage}
                    />
                )
            })
    };

    localize();

    const handleChange = (event) => {
        const r = rank;
        const field = event.target.id
        field === "input-title" ? rank.title = event.target.value : rank.position = event.target.value;
        setRank(r);
        setValue(value + 1);
    };

    const closeEditRankView = e => {
        e.preventDefault();

        setShowRank(false);
        setRank(resourceHelper.emptyRank());
    };

    const startAddingRank = (e) => {
        e.preventDefault();

        setShowRank(true);
    };

    function updateRank(e) {
        e.preventDefault();

        if (rank.id) {
            businessApiService.updateRank(rank)
                .then(res => {
                    businessHelper.saveUserSession(res)
                    setRanks(res.user.student_ranks);
                    setRank(resourceHelper.emptyRank);
                    setShowRank(false);
                })
                .catch(function (error) {
                    console.log(JSON.stringify(error)); // TODO
                });
        } else {
            businessApiService.createRank(rank)
                .then(res => {
                    businessHelper.saveUserSession(res)
                    setRanks(res.user.student_ranks);
                    setRank(resourceHelper.emptyRank);
                    setShowRank(false);
                })
                .catch(function (error) {
                    console.log(JSON.stringify(error)); // TODO
                });
        }
    }

    function setColor(e, color) {
        e.preventDefault();
        rank.color = color
        setRank(rank)
        setValue(value + 1)
    }

    function setIcon(e, icon) {
        e.preventDefault();
        rank.icon = icon
        setRank(rank)
        setValue(value + 1)
    }

    // function rankIconBackground(icon) {
    //     return rank && rank.icon === icon ? "success" : "white";
    // }

    function createIconPath(icon) {
        return require(`assets/img/icons/ranks/${icon}/${icon}-${rank.color}.svg`);
    }

    return (
        <>
            <Label className="text-white">{commonStrings.rank_expl}</Label>
            <FormGroup className="mt-0 mb-1 mt-0 text-center">
                {!showRank &&
                <Button
                    color="warning"
                    onClick={e => startAddingRank(e)}
                    size="lg"
                >
                    {commonStrings.add_new_rank}
                </Button>
                }
            </FormGroup>

            {/*Edit rank*/}

            {showRank &&
            <CardBody>
                {/*{rank.teacher_id} {rank.room_id}*/}
                <Form>
                    <div className="pl-lg-4">
                        <Row>
                            <Col lg="9">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-start"
                                    >
                                        {resourceStrings.title}
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        onChange={handleChange}
                                        placeholder={resourceStrings.rank_placeholder}
                                        defaultValue={rank && rank.title ? rank.title : ""}
                                        id="input-title"
                                        type="text"
                                    />
                                </FormGroup>
                            </Col>

                            <Col lg="3">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-start"
                                    >
                                        {resourceStrings.priority}
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        onChange={handleChange}
                                        placeholder="1, 2, 3..."
                                        defaultValue={rank.position}
                                        id="input-position"
                                        type="number"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                    >
                                        {resourceStrings.icon}
                                    </label>
                                    <Row>
                                        <Col lg="12">
                                            {icons.map((icon, index) => {
                                                return (
                                                    <Button style={{marginRight: '0.5rem', marginTop: '0.5rem'}}
                                                            key={icon}
                                                            color={rank.icon === icon ? "default" : "gray"}
                                                            onClick={e => setIcon(e, icon)}
                                                    >
                                                        <img
                                                            width={24}
                                                            height={24}
                                                            alt=""
                                                            src={createIconPath(icon)}
                                                        />
                                                    </Button>
                                                )
                                            })
                                            }
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                    >
                                        {resourceStrings.color}
                                    </label>
                                    <Row>
                                        <Col lg="12">
                                            {colors.map((color, index) => {
                                                return (
                                                    <Button style={{
                                                        marginRight: '0.5rem',
                                                        marginTop: '0.5rem',
                                                        backgroundColor: `#${color}`
                                                    }}
                                                            onClick={e => setColor(e, color)}>
                                                        <span
                                                            style={{color: "white"}}>{rank && rank.color === color ? "✔" : ""}</span>
                                                    </Button>
                                                )
                                            })
                                            }
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>

                    <Row>
                        <Col lg="12">
                            <Col className="text-right">
                                <Button
                                    color="warning"
                                    outline="button"
                                    size="lg"
                                    onClick={e => closeEditRankView(e)}
                                >
                                    {commonStrings.close}
                                </Button>

                                <Button
                                    color="default"
                                    size="lg"
                                    disabled={rank.title.length === 0}
                                    onClick={e => updateRank(e)}
                                >
                                    {commonStrings.save}
                                </Button>
                            </Col>
                        </Col>
                    </Row>

                </Form>
            </CardBody>
            }

            {/*Existing rules*/}
            {!showRank &&
            <Row>
                <Col xl="12">

                    {groupHelpers.groups().length > 0 &&
                    <Table
                        className="align-items-center table-dark table-flush mt-2"
                        responsive
                    >
                        <tbody>
                            {renderTableData()}
                        </tbody>
                    </Table>
                    }
                </Col>
            </Row>
            }
        </>
    );
};

export default RanksOverview;